module.exports = __webpack_public_path__ + "media/images/lift-elevator-3-b609736e82d0c43bcd0bd784fdca8126.jpg";